import * as React from "react";
const SvgCloseCircle = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M30.7279 30.7279C27.3523 34.1036 22.7739 36 18 36C13.2261 36 8.64773 34.1036 5.27208 30.7279C1.89642 27.3523 0 22.7739 0 18C0 13.2261 1.89642 8.64773 5.27208 5.27208C8.64773 1.89642 13.2261 0 18 0C22.7739 0 27.3523 1.89642 30.7279 5.27208C34.1036 8.64773 36 13.2261 36 18C36 22.7739 34.1036 27.3523 30.7279 30.7279ZM25.846 12.3399C26.4513 11.7346 26.4513 10.7593 25.846 10.154C25.2407 9.54869 24.2653 9.54869 23.6601 10.154L18 15.8141L12.3398 10.154C11.7346 9.54869 10.7592 9.54869 10.1539 10.154C9.54863 10.7593 9.54863 11.7346 10.1539 12.3399L15.814 18L10.1539 23.6601C9.54863 24.2654 9.54863 25.2408 10.1539 25.846C10.7592 26.4513 11.7346 26.4513 12.3398 25.846L18 20.1859L23.6601 25.846C24.2653 26.4513 25.2407 26.4513 25.846 25.846C26.4513 25.2408 26.4513 24.2654 25.846 23.6601L20.1859 18L25.846 12.3399Z"
}));
export default SvgCloseCircle;
